<template>
  <a-modal v-model="visible" @ok="handleOk" :bodyStyle="{ padding: 0 }" wrap-class-name="my-special-modal" :centered="true" width="100%" @cancel="CancelModal" height="100vh" :footer="null">
    <div class="container">
      <img class="logo-image" src="../../assets/images/sidelogo-addphy.png" rel="preload" alt="logo" />
      <div class="right-side">
        <div v-if="page == 'first'" class="right-content-page2">
          <h1>Suggest a Non For Profit Organization</h1>
          <h3>Fill in the Non For Profit Organization details</h3>
          <div class="input-name name">
            <label for="name">Bussines/Nfp Name<span class="required">*</span></label>
            <input type="text" id="name" placeholder="Enter name" v-model.lazy="$v.bName.$model" />
            <div class="error-container" v-if="$v.bName.$error">
              <div class="error-item" v-if="!$v.bName.required">Name is required</div>
            </div>
          </div>
          <div class="input-name name">
            <label for="number">Phone Number <span class="required">*</span></label>
            <a-input type="tel" id="number" placeholder="Enter phone number" v-model.lazy="$v.bPhone.$model" :maxLength="14" />
            <div class="error-container" v-if="$v.bPhone.$error">
              <div class="error-item" v-if="!$v.bPhone.required">Phone Number is required</div>
              <div class="error-item" v-if="!$v.bPhone.minLength">length should be 10</div>
            </div>
          </div>
          <div class="address-input name">
            <div class="City-input">
              <label for="city">City <span class="required">*</span></label>
              <div class="search-input position-relative">
                <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute search-icon" />
                <a-select
                  v-model="citySelect"
                  show-search
                  :size="'large'"
                  class="city-input input"
                  placeholder="Search City"
                  style="width: 278.5px"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :defaultValue="city"
                  :notFoundContent="null"
                  id="city"
                  @search="val => getLocations(val)"
                  @select="val => selectLocation(val)"
                >
                  <a-select-option v-if="loadingLocation" :key="0" :disabled="true">
                    <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                  </a-select-option>
                  <template v-else>
                    <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)">{{ c.name }}, {{ c.state }} </a-select-option>
                  </template>
                </a-select>
              </div>
              <div class="error-container" v-if="$v.city.$error">
                <div class="error-item" v-if="!$v.city.required">City is required</div>
              </div>
            </div>
            <div class="zipCode-input">
              <label for="zipcode">Zipcode</label>
              <a-select class="city-input input" :min="0" :size="'large'" placeholder="Zipcode" v-model="$v.postalCode.$model" :disabled="city ? false : true" style="width: 278.5px">
                <a-select-option v-if="loadingZipCodes" :key="0" :disabled="true">
                  <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                </a-select-option>
                <template v-else>
                  <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode"> {{ zipcode }} </a-select-option>
                </template>
              </a-select>
              <div class="error-container" v-if="$v.postalCode.$error">
                <div class="error-item" v-if="!$v.postalCode.required">Zip/Postal code is required</div>
              </div>
            </div>
          </div>
          <div class="input-name name">
            <label for="street">Number, Street</label>
            <input type="text" id="street" placeholder="Enter number and street" v-model.lazy="$v.street.$model" />
            <div class="error-container" v-if="$v.street.$error">
              <div class="error-item" v-if="!$v.street.required">Address is required</div>
            </div>
          </div>
          <div class="input-name name">
            <label for="street">Website</label>
            <input type="text" id="street" placeholder="Link" v-model.lazy="$v.website.$model" />
          </div>
          <div>
            <button @click="addProvider" :loading="loading" class="next-btn" :style="{ background: getPrimaryColor() }">Submit</button>
          </div>
        </div>
        <div v-if="page == 'second'" class="right-content-submit">
          <div>
            <img class="submit-mark" src="../../assets/images/addphy-submit.png" alt="submit-rightmark" />
          </div>
          <div class="submit-message">
            <h3><strong> Thank you for</strong></h3>
            <h3>
              <strong>Suggesting a Non For Profit Organization!</strong>
            </h3>
          </div>
          <div class="sub-message">
            <p>DoveMed will review this Non For Profit Organization and inform you once it's listed on Mycircles.</p>
          </div>
          <div class="mobile-btn">
            <button @click="handleOk" class="submit-btn" :style="{ background: getPrimaryColor() }">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { required, requiredIf, minLength, maxLength, email } from "vuelidate/lib/validators"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import axios from "axios"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AddNfpModal",
  props: { handleChangeTab: Function },
  data() {
    return {
      type: "nfp",
      page: "first",
      visible: false,
      details: [],
      circle_id: null,
      bName: undefined,
      bEmail: undefined,
      website: undefined,
      bPhone: undefined,
      npiNumber: undefined,
      street: undefined,
      state: "",
      city: undefined,
      postalCode: undefined,
      loading: false,
      locationsList: [],
      zipCodeArray: [],
      phoneNum: undefined,
      loadingLocation: false,
      loadingZipCodes: false,
      citySelect: undefined,
    }
  },

  validations: {
    bName: {
      required,
    },
    //   bEmail: {
    //     required,
    //     email
    //   },
    website: {},
    bPhone: {
      // required,
      minLength: minLength(14),
      maxLength: maxLength(14),
    },
    npiNumber: {
      required: requiredIf(function() {
        return this.type === "provider"
      }),
    },
    street: {
      // required
    },
    city: {
      required,
    },
    postalCode: {
      // required
    },
  },

  watch: {
    bPhone: function(val) {
      if (!val) {
        return
      }
      let output = "("
      this.bPhone.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function(match, g1, g2, g3) {
        if (g1.length) {
          output += g1
          if (g1.length == 3) {
            output += ")"
            if (g2.length) {
              output += " " + g2
              if (g2.length == 3) {
                output += "-"
                if (g3.length) {
                  output += g3
                }
              }
            }
          }
        }
      })
      this.bPhone = output
    },
  },

  methods: {
    showModal(circle_id) {
      this.visible = !this.visible
      this.getLocations("")
      this.circle_id = circle_id
    },
    handleOk() {
      if (this.page === "second") {
        this.CancelModal()
      }
    },
    CancelModal() {
      this.page = "first"
      this.$v.$reset()
      this.bEmail = null
      this.bName = null
      this.bPhone = null
      this.npiNumber = null
      this.street = null
      this.website = null
      this.city = null
      this.postalCode = undefined
      this.citySelect = undefined
      this.visible = false
      this.handleChangeTab()
    },
    setpage(pageno) {
      this.page = pageno
    },
    async getLocations(city) {
      // AppRepository.getLocations(city)
      //   .then(res => {
      //     this.locationsList = res.data.data && res.data.data.data
      //   })
      //   .catch(err => null)

      try {
        this.loadingLocation = true
        const coreLocationResponse = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/city/?name=${city}`)
        this.locationsList = coreLocationResponse.data.results || []
        this.loadingLocation = false
      } catch (e) {
        this.loadingLocation = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching location" })
      }
    },

    async selectLocation(val) {
      const value = JSON.parse(val)
      this.state = value.state
      this.city = value.name
      // this.zipCodeArray = [...value.city_zipcodes]
      try {
        this.loadingZipCodes = true
        const zipCodeRes = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/zipcode/?page_size=50&city=${value.name}`)
        this.zipCodeArray = zipCodeRes.data.results.map(data => data.zipCode) || []
        this.loadingZipCodes = false
      } catch (e) {
        this.loadingZipCodes = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching zip codes" })
      }
    },

    addProvider() {
      this.empty = !this.$v.$anyDirty
      this.errors = this.$v.$anyError

      if (this.$v.$anyError === false && this.empty === false && this.city != null && this.bName != null) {
        this.loading = true
        const data = {
          name: this.bName,
          email: null,
          phone: this.bPhone,
          type: this.type,
          website_link: this.website,
          npi_number: null,
          circle_id: this.circle_id,
          user_id: this.authUser.user.id,
          user_role: this.authUser.user.role,
          location: { address_line1: this.street, address_line2: "", city: this.city, state: this.state, country: "USA", zip_code: this.postalCode },
        }

        UserRepository.addProvider(data)
          .then(res => {
            this.loading = false
            this.bName = null
            this.bEmail = null
            this.bPhone = null
            this.npiNumber = null
            this.street = null
            this.city = null
            this.postalCode = null
            this.$v.$reset()

            this.setpage("second")
          })
          .catch(err => {
            this.loading = false

            if (err.response.data.message.includes("this npi number already exists")) {
              this.notify("error", "Error", "NPI number has to be unique")
            } else {
              this.notify("error", "Error", "Something went wrong !")
            }
          })
      } else {
        this.$v.$touch()
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 769px) {
  .logo-image {
    width: 350px !important;
  }
  .input-name > input {
    width: 278.5px !important;
  }
  .address-input {
    flex-direction: column !important;
    gap: 24px;
    height: 100% !important;
  }
  .next-btn {
    width: 278.5px !important;
    margin-bottom: 24px !important;
  }
  .link a {
    margin-left: 0px !important;
  }
  .right-content-page2 {
    padding: 10px !important;
  }

  .right-content-submit {
    align-items: flex-start !important;
  }

  .submit-mark {
    margin-left: 145px;
  }

  .submit-message {
    width: 380px !important;
  }
  .sub-message {
    width: 350px !important;
    align-self: center !important;
  }
  .mobile-btn {
    align-self: center !important;
  }
  .submit-btn {
    // margin-left: 125px;
    margin-top: 30px !important;
  }
}

@media screen and (max-width: 426px) {
  .logo-image {
    display: none;
    height: 100% !important;
  }
  .input-name > input {
    width: 327px !important;
  }

  .link a {
    margin-left: 0px !important;
  }
  .next-btn {
    width: 327px !important;
    margin-bottom: 24px !important;
  }
  .right-content-page2 {
    margin-top: 24px !important;
  }

  .address-input {
    flex-direction: column !important;
    gap: 24px;
    height: 100% !important;
  }
  .container {
    justify-content: center;
  }

  .sub-message {
    width: 320px !important;
  }
  .right-side {
    margin-left: 50px !important;
  }

  .right-content-submit {
    margin-right: 0px !important;
    height: 100vh !important;
    margin-top: 0px !important;
  }

  .submit-btn {
    margin-top: 30px !important;
  }
}

@media screen and (max-height: 1024px) {
  .container {
    height: 100% !important;
  }
  .logo-image {
    height: 100vh !important;
  }
}

@media screen and (max-width: 1275px) {
  .right-side {
    margin-left: 50px !important;
  }
}

@media screen and (max-width: 1150px) {
  .logo-image {
    width: 390px;
  }
  .right-side {
    margin-left: 24px !important;
  }
}

.search-input {
  display: flex;
  align-items: center;
  position: relative;
}
.search-icon {
  left: 5px;
  font-size: 20px;
  color: #94a3b8;
  z-index: 1;
  margin-left: 12px;
}
.container {
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-left: 0px;
  height: 100vh;
  margin-left: 0px;
}

.next-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 581px;
  height: 48px;
  background: #2a71d4 !important;
  border-radius: 6px;
  margin-top: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  border: none;
}
.logo-image {
  margin-left: 0px;
  height: 100vh;
}
.input-name {
  display: flex;
  flex-direction: column;
}
.number {
  padding-top: 31px;
}
.name {
  padding-top: 24px;
}
.input-name label {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  height: 24px;
  margin-bottom: 4px;
  text-align: start;
}

.input-name input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  width: 581px;
  height: 56px;
}
.input-name input:focus {
  outline: none !important;
}
.backimg {
  margin-left: 917px;
  margin-top: 30.23px;
  margin-right: 29.77px;
}
.link a {
  color: #2a71d4 !important;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  width: 581px;
  height: 21px;
  align-self: stretch;
  margin-left: 368px;
}
.link {
  margin-top: 16px;
}
.right-side {
  padding: 0;
  margin-left: 189px;
}
.right-content {
  padding: 0;
  margin-top: 117.5px;
}
.right-content h1 {
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
}
.right-content h3 {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 24px;
}

.right-content-page2 {
  padding: 0px;
  margin-top: 56px;
}

.right-content-page2 h1 {
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
}

.right-content-page2 h3 {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.address-input {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 278.5px;
  height: 84px;
  margin-top: 24px;
}

.City-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  margin-right: 24px;
}

.City-input label {
  color: #647490;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
  margin-bottom: 4px;
  text-align: start;
}

.City-input input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 12px 16px;
  width: 278.5px;
  height: 56px;
}
.City-input input:focus {
  outline: none;
}

.options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  margin-top: 24px;
  width: 581px;
  height: 58px;
}
.options label {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.options input {
  border: 2px solid #94a3b8;
  box-sizing: border-box;
}

.option1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 581px;
  height: 21px;
}
.option2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 581px;
  height: 21px;
  margin-top: 6px;
}

.right-content-submit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 134px;
  // margin-right: 190px;
}

.submit-mark {
  width: 66.67px;
  height: 66.67px;
}
.submit-message {
  // height: 84px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  color: #0f1734;
  margin-top: 29px;
}
.sub-message {
  width: 581px;
  // height: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #647490;
  margin-top: 8px;
}

.submit-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 106px;
  height: 48px;
  background: #2a71d4 !important;
  border-radius: 6px;
  margin-top: 24px;
  border: none;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
}
.submit-message h3 {
  margin-bottom: 0;
}

.right-content-exist {
  display: flex;
  flex-direction: column;
  padding: 0px;

  position: absolute;
  margin-top: 118px;
}

.exists-title {
  width: 581px;
  height: 84px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734 !important;
  text-align: start;
  margin-bottom: 8px;

  h3 {
    margin-bottom: 0;
  }
}
.exits-message {
  width: 581px;
  height: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490 !important;
  text-align: start;
  margin-top: 8px;

  p {
    margin-top: 8px;
  }
}
.master-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  width: 581px;
  height: 178px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-top: 24px;
}
.submit-btns {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 587px;
  height: 144px;
  background: #ffffff;
  border-radius: 8px;
}

.view-profile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 587px;
  height: 48px;
  background: #2a71d4;
  border-radius: 6px;
  text-align: center;
  border: none;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff !important;
  margin-top: 24px;
}
.npi-number {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 587px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  text-align: center;
  text-transform: capitalize;
}
.profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  width: 93px;
  height: 126px;

  img {
    height: 70px;
    width: 70px;
    left: 0px;
    top: 0px;
    border-radius: 50%;
    border: 1px solid #f8fafd;
  }
}

.divider {
  height: 176px;
  border: 1px solid #cbd5e1 !important;
  margin-left: 24px;
  margin-top: -25px;
}
.details-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 392px;
  height: 111px;
}
.nameofphy {
  height: 30px;
  width: max-content;
}
.nameofphy h5 {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin: 24px 24px 17px 24px;
  align-items: start;
  display: flex;
}
.medicine {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  width: 112px;
  height: fit-content;
  background: #e1eaf7;
  border-radius: 4px;
  margin: 17px 96px 85px 24px;
}
.medicine p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
  margin-bottom: 0;
}
.card-number {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 126px;
  height: 24px;
  p {
    margin-bottom: 0;
    margin-left: 0.03px;
    color: #0f1734 !important;
  }
}
.card-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 152px;
  height: 42px;
  margin-top: 13.5px;
}

.location-complete {
  height: 42px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
}

.location-complete p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-bottom: 0;
  align-items: start;
  display: flex;
  margin-left: 8.5px;
}
.card-distance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 0px 28px;
  height: 21px;
  margin-top: 12px;
  display: flex;
  align-items: start;
}
.star-rating {
  width: 140.53px;
  height: 16px;
  margin-top: 4px;
  margin-bottom: 5px;
  li {
    margin: 0 1px 0 0;
  }
}
.ant-rate-star {
  margin: 0 1px 0 0;
}

.rating {
  margin-top: 5px;
  p {
    margin-bottom: 0;
  }
}
.required {
  color: tomato !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AddNfpModal.vue